import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import AcceptInviteModal from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/AcceptInviteModal'
import DeclineInviteModal from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/DeclineInviteModal'
import { Button } from '@/components/ui/button'
import useDialog from '@/hooks/useDialog'
import { usePermissions } from '@/hooks/usePermissions'
import { faCheck, faTimes } from '@/lib/fontAwesomePro/regular'
import { CompanyProfileItemPanel } from '@/types/responses/companies'

interface Props {
  panel: CompanyProfileItemPanel
}

const RespondToInviteButtons: React.FC<Props> = ({ panel }) => {
  const {
    isShowingDialog: isShowingAcceptDialog,
    showDialog: showAcceptDialog,
    hideDialog: hideAcceptDialog,
  } = useDialog()

  const {
    isShowingDialog: isShowingRejectDialog,
    showDialog: showRejectDialog,
    hideDialog: hideRejectDialog,
  } = useDialog()

  const { canAddPanelDirectly } = usePermissions()

  return (
    <>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button
          onClick={showAcceptDialog}
          variant="success"
          size="sm"
          className="w-full"
          disabled={!canAddPanelDirectly}
        >
          <FontAwesomeIcon icon={faCheck} />
          Accept
        </Button>

        {isShowingAcceptDialog && (
          <AcceptInviteModal
            panel={panel}
            onAccept={hideAcceptDialog}
            onHide={hideAcceptDialog}
          />
        )}

        <Button
          onClick={() => {
            showRejectDialog()
          }}
          variant="outline-destructive"
          size="sm"
          className="w-full"
          disabled={!canAddPanelDirectly}
        >
          <FontAwesomeIcon icon={faTimes} />
          Decline
        </Button>

        {isShowingRejectDialog && (
          <DeclineInviteModal onHide={hideRejectDialog} panel={panel} />
        )}
      </div>
      {!canAddPanelDirectly && (
        <div className="text-dim text-xs">
          An admin must approve this request
        </div>
      )}
    </>
  )
}

export default RespondToInviteButtons
